module.exports = __webpack_public_path__ + "img/IMG-20191012-WA0700.d66ef3b0.jpg";